import { SxProps, Theme } from '@mui/material'

export const mainPaperStyle: SxProps<Theme> = {
  width: '100%',
  mb: 6,
  py: { xs: 2.4, md: 4.8 },
  px: { xs: 1.2, md: 3.2 },
}
